import React from 'react';
import HistoryTableHeader from './historyTableHeader';
import { ProductReleaseTableColumnCaptions } from './tableColumnCaptions';

const ProductReleaseHistoryTableHeader = (props) => {
  const { editedFields, objectData } = props;

  const title = [{
    title: ProductReleaseTableColumnCaptions.productRelease,
    value: objectData
      ? `${objectData.productName} v${objectData.productVersion}`
      : '',
  }];

  const extraProperties = ['productName', 'productVersion'];

  return <HistoryTableHeader editedFields={editedFields} captions={ProductReleaseTableColumnCaptions} objectData={objectData} title={title} extraProperties={extraProperties}/>
};

export default ProductReleaseHistoryTableHeader;


// WEBPACK FOOTER //
// ./src/components/productReleaseHistoryTableHeader.js